export enum SpinnerType {
  ROUND_ARROW,
}
